import { useState, useEffect } from 'react';
import { Music, Sparkles } from 'lucide-react';

export const DiscoBall = ({ className = "w-32 h-32" }) => {
  const [isVibrating, setIsVibrating] = useState(false);
  const [particles, setParticles] = useState([]);

  const triggerAnimation = () => {
    // Trigger vibration
    setIsVibrating(true);
    
    // Create music notes and stars in a circular pattern around the disco ball
    const particleCount = 20; // Total particles (mix of notes and stars)
    const newParticles = Array.from({ length: particleCount }, (_, i) => {
      // Calculate angle for circular distribution
      const angle = (i / particleCount) * 2 * Math.PI;
      const radius = 120 + Math.random() * 50; // Random radius between 120-170px
      
      // Calculate x and y position in a circle
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      
      return {
        id: Date.now() + i,
        x: x,
        y: y,
        rotation: Math.random() * 360,
        delay: i * 0.04, // Fast cascade
        color: i % 2 === 0 ? '#D4AF37' : '#335B7A', // Alternate between gold and blue
        type: i % 3 === 0 ? 'star' : 'note' // Mix stars and notes
      };
    });
    
    setParticles(newParticles);
    
    // Remove vibration after animation
    setTimeout(() => setIsVibrating(false), 500);
    
    // Remove particles after animation
    setTimeout(() => setParticles([]), 1800);
  };

  // Auto-play animation on component mount
  useEffect(() => {
    // Delay the animation slightly so it plays after page load
    const timer = setTimeout(() => {
      triggerAnimation();
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    triggerAnimation();
  };

  return (
    <div className={`${className} relative flex items-center justify-center`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/jd9h3tyt_PLEASE%20WORK.png" 
        alt="Disco Ball"
        className={`w-full h-full object-contain cursor-pointer transition-transform ${
          isVibrating ? 'animate-vibrate' : 'hover:scale-105'
        }`}
        onClick={handleClick}
      />
      
      {/* Music Notes and Stars in circular pattern */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-float-away pointer-events-none"
          style={{
            left: `calc(50% + ${particle.x}px)`,
            top: `calc(50% + ${particle.y}px)`,
            animationDelay: `${particle.delay}s`,
            transform: `rotate(${particle.rotation}deg)`,
            color: particle.color
          }}
        >
          {particle.type === 'star' ? (
            <Sparkles className="w-6 h-6" style={{ color: particle.color }} />
          ) : (
            <Music className="w-7 h-7" style={{ color: particle.color }} />
          )}
        </div>
      ))}
    </div>
  );
};

export const HeartArrow = ({ className = "w-24 h-24" }) => {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Heart - no arrow */}
      <path 
        d="M50 85 C30 70 15 55 15 40 C15 30 22 22 32 22 C40 22 47 28 50 35 C53 28 60 22 68 22 C78 22 85 30 85 40 C85 55 70 70 50 85 Z" 
        stroke="#D4AF37" 
        strokeWidth="3" 
        fill="none"
      />
    </svg>
  );
};